module.exports = __webpack_public_path__ + "static/background-1-714b6eb30d883fbfe6987a950c212cd5.png";